import { Judgement } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryNominationJudgement: (
  fetchContext: FetchContext,
  nominationId: number,
  userId: number,
  countryId: number,
  accessToken?: string,
) => Promise<Judgement> = (fetchContext, nominationId, userId, countryId, accessToken) =>
    fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/judges/${userId}/country/${countryId}/judgement`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      })
      .then((response) => responseErrorHandler<Judgement>(fetchContext.errorStore, response, 'get country nomination judgedment'));